import { CoreApiVersionPath, RosaCoreApiService } from '@/rosa';
import { Injectable, inject } from '@angular/core';
import type { Moment } from 'moment';
import type { Observable } from 'rxjs';
import type { BuildingId } from '../../interfaces/Building.interface';
import type { IpeTileData, MultiSensorTileCreationBody, TileData } from '../../interfaces/Tile.interface';
import { API_DATE_FORMAT } from '../constants.api';

@Injectable({
    providedIn: 'root'
})
export class AdvizeoCoreTilesProvider {
    private _rosaCoreApiService = inject(RosaCoreApiService);

    fetchBuildingTilesByGroup$(
        buildingId: BuildingId,
        tileGroup: string,
        dateStart: Moment,
        dateEnd: Moment,
        isVatIncl: boolean
    ): Observable<TileData[]> {
        const params: string[] = [];
        if (buildingId) {
            params.push('buildingId=' + buildingId);
        }
        if (tileGroup) {
            params.push('tileGroup=' + tileGroup);
        }
        if (dateStart) {
            params.push('dateStart=' + dateStart.format(API_DATE_FORMAT));
        }
        if (dateEnd) {
            params.push('dateEnd=' + dateEnd.format(API_DATE_FORMAT));
        }
        params.push('isVatIncl=' + isVatIncl);

        let paramsQuery = '';
        if (params.length > 0) {
            paramsQuery = '?' + params.join('&');
        }

        return this._rosaCoreApiService.get(`${CoreApiVersionPath.V3}tiles${paramsQuery}`);
    }

    createTile$(tile: any): Observable<string> {
        return this._rosaCoreApiService.post(`${CoreApiVersionPath.V3}tiles/ipe`, tile);
    }

    updateTile$(id: string, tile: any): Observable<string> {
        return this._rosaCoreApiService.put(`${CoreApiVersionPath.V3}tiles/ipe/${id}`, tile);
    }

    renameTile$(tileId: string, newName: string): Observable<void> {
        const body = {
            newValue: newName
        };
        return this._rosaCoreApiService.patch(`${CoreApiVersionPath.V3}tiles/${tileId}/name`, body);
    }

    getIpeTilePreview$(preview: any, dateStart: string, dateEnd: string): Observable<IpeTileData> {
        return this._rosaCoreApiService.post(
            `${CoreApiVersionPath.V3}tiles/ipe/preview?dateStart=${dateStart}&dateEnd=${dateEnd}`,
            preview
        );
    }

    deleteTile$(tileId: string, buildingId: BuildingId): Observable<any> {
        return this._rosaCoreApiService.delete(`${CoreApiVersionPath.V3}buildings/${buildingId}/tiles/${tileId}`, {
            'Content-Type': 'application/json'
        });
    }

    createMultiTile(body: MultiSensorTileCreationBody): Observable<string> {
        return this._rosaCoreApiService.post(`${CoreApiVersionPath.V3}tiles/multi-sensors`, body);
    }
}
